<table>
  <thead>
      <tr>
          <th class="subtable id">{{'mantenimientoCultivos.tabs.designaciones.table.id' | translate}}</th>
          <th class="subtable string">{{'mantenimiento-entidades-control.auditores.auditor' | translate}}</th>
          <th class="subtable string">{{'mantenimiento-entidades-control.auditores.usuario' | translate}}</th>
          <th class="subtable short">{{'mantenimiento-entidades-control.auditores.permisoEscritura' | translate}}</th>
          <th class="subtable short">{{'mantenimiento-entidades-control.auditores.gestionRoyalties' | translate}}</th>
      </tr>
  </thead>
  <tbody *ngFor="let auditor of auditores">
      <tr>
          <td class="id">{{auditor.id}}</td>
          <td class="string">{{auditor.des}}</td>
          <td class="string">{{auditor.userName}}</td>
          <td class="short">
            <input type="checkbox" id="permisoEscritura" [checked]="auditor.permisoEscritura" [disabled]="true">
            <label for="permisoEscritura" style="margin-bottom: unset;"></label>
          </td>
          <td class="short">
            <input type="checkbox" id="gestionRoyalties" [checked]="auditor.gestionRoyalties" [disabled]="true">
            <label for="gestionRoyalties" style="margin-bottom: unset;"></label>
          </td>
      </tr>
  </tbody>
  <tfoot *ngIf="!auditores || (auditores && auditores.length < 1)">
      <tr>
        <td colspan="3">
          {{'global.noContent' | translate}}
        </td>
      </tr>
  </tfoot>
</table>
<app-paginator *ngIf="auditores && auditores.length > 0" [itemsPerPage]="itemsPerPage"
    [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages" [hiddeItems]="true"
    (pageChange)="pageChange($event)"></app-paginator>
